import React from 'react'
import { observer } from 'mobx-react'
import OwnedTargetGroup from './OwnedTargetGroup'
import SharedTargetGroup from './SharedTargetGroup'

const TargetGroupPane = ({ group }) => (
  group.is_owner
    ? <OwnedTargetGroup group={group} />
    : <SharedTargetGroup group={group} />
)

export default observer(TargetGroupPane)
